<div class="modal">
  <div class="header">
    <div class="container">
      <mat-icon class="icon" fontSet="material-icons-round">checklist</mat-icon>
      <span class="kbody-huge">Course Validation</span>
    </div>
    <mat-icon
      class="close"
      fontSet="material-icons-round"
      (click)="this.dialogRef.close()"
      >close</mat-icon
    >
  </div>
  <div class="content">
    <div>
      <div class="title-row">
        <span class="ktitle-tiny">{{ data.courseName }}</span>
        <div class="title-row-right">
          <span class="klabel-huge"
            >COURSE ID:
            <span class="id kbody-large">{{ data.courseItemId }}</span></span
          >
          <div class="sheet-actions">
            <app-button
              [text]="'Download Sign-in Sheet'"
              [class]="'white'"
              [icon]="{ materialIcon: 'download' }"
              (click)="downloadValidationSheet()"
            ></app-button>
            <app-button
              [text]="'Upload Sign-in Sheet'"
              [class]="'white'"
              [icon]="{ materialIcon: 'upload' }"
              (click)="triggerSheetUpload()"
            ></app-button>
            <input
              #validationSheetInput
              type="file"
              accept=".csv,text/csv"
              (change)="onSheetUpload($event)"
              hidden
            />
          </div>
        </div>
      </div>
      <div class="sheet-warnings" *ngIf="rejectedWalkIns.length > 0">
        <mat-icon class="warning-icon" fontSet="material-icons-round">warning</mat-icon>
        <div class="warning-content">
          <span class="klabel-medium"
            >{{ rejectedWalkIns.length }} sign-in sheet
            {{ rejectedWalkIns.length === 1 ? "entry" : "entries" }} could not be
            added to this course</span
          >
          <span class="kbody-small warning-row" *ngFor="let rejected of rejectedWalkIns"
            >{{ rejected.email }} — {{ rejected.message }}</span
          >
        </div>
        <mat-icon
          class="warning-close"
          fontSet="material-icons-round"
          (click)="dismissWalkInWarnings()"
          >close</mat-icon
        >
      </div>
      <div class="titles-row">
        <div class="validation-buttons">
          <mat-icon
            class="icon confirm"
            fontSet="material-icons-round"
            (click)="approveAll()"
            [ngClass]="{ selected: styleButton('COMPLETED') }"
            >check</mat-icon
          >
          <mat-icon
            class="icon unmarked"
            fontSet="material-icons-round"
            (click)="unmarkAll()"
            >horizontal_rule</mat-icon
          >
          <mat-icon
            class="icon deny"
            fontSet="material-icons-round"
            (click)="denyAll()"
            [ngClass]="{ selected: styleButton('NOT_TAKEN') }"
            >close</mat-icon
          >
        </div>
        <div
          class="title"
          *ngFor="let title of tableTitles"
          [ngClass]="[title?.class ?? '', title.sortBy ? 'sortable' : '']"
          (click)="title.sortBy && sortColumn(title.sortBy)"
        >
          <span class="klabel-medium label">{{ title.name }}</span>
          <mat-icon
            *ngIf="title.sortBy"
            class="sort-arrow"
            fontSet="material-icons-round"
            [ngClass]="{
              ascending: title.sortBy === sortOrder.sortBy && sortOrder.direction === 'ASC'
            }"
          >arrow_upward</mat-icon>
        </div>
      </div>
      <div class="items">
        <div class="item" *ngFor="let user of sessionValidationDetails?.rows">
          <div class="validation-buttons">
            <mat-icon
              class="icon confirm"
              fontSet="material-icons-round"
              (click)="updateIndividualValidation(user, 'COMPLETED')"
              [ngClass]="{ selected: isApproved(user) }"
              >check</mat-icon
            >
            <mat-icon
              class="icon unmarked"
              fontSet="material-icons-round"
              (click)="updateIndividualValidation(user, 'REGISTERED')"
              [ngClass]="{
                selected: !(isApproved(user) || isDenied(user))
              }"
              >horizontal_rule</mat-icon
            >
            <mat-icon
              class="icon deny"
              fontSet="material-icons-round"
              (click)="updateIndividualValidation(user, 'NOT_TAKEN')"
              [ngClass]="{ selected: isDenied(user) }"
              >close</mat-icon
            >
          </div>
          <div class="detail">
            <span class="kbody-medium"
              >{{ user?.firstName }} {{ user?.lastName }}</span
            >
          </div>
          <div class="detail email">
            <span class="kbody-medium">{{ user?.loginName }}</span>
          </div>
          <div class="detail">
            <app-input
              value="{{ user.adjustedValue }}"
              placeholder="1"
              (change)="updateAdjustedValue(user, $event)"
              [type]="'number'"
            ></app-input>
          </div>
          <div class="detail status-detail">
            <span
              class="kbody-medium status"
              [ngClass]="user?.currentStatusKid | lowercase"
              >{{ user?.currentStatusText | lowercase }}</span
            >
          </div>
          <div class="detail time">
            <app-input
              value="{{ user.timeIn }}"
              placeholder="—"
              (change)="updateTime(user, $event, 'timeIn')"
            ></app-input>
          </div>
          <div class="detail time">
            <app-input
              value="{{ user.timeOut }}"
              placeholder="—"
              (change)="updateTime(user, $event, 'timeOut')"
            ></app-input>
          </div>
        </div>
        <div class="item walk-in" *ngFor="let walkIn of walkIns">
          <div class="validation-buttons">
            <mat-icon
              class="icon confirm selected static"
              fontSet="material-icons-round"
              title="Attendees added from the sign-in sheet are marked completed"
              >check</mat-icon
            >
            <mat-icon
              class="icon deny"
              fontSet="material-icons-round"
              title="Remove this attendee"
              (click)="removeWalkIn(walkIn)"
              >close</mat-icon
            >
          </div>
          <div class="detail">
            <span class="kbody-medium"
              >{{ walkIn.firstName }} {{ walkIn.lastName }}</span
            >
          </div>
          <div class="detail email">
            <span class="kbody-medium">{{ walkIn.email }}</span>
          </div>
          <div class="detail">
            <app-input
              value="{{ walkIn.adjustedValue }}"
              placeholder="1"
              (change)="updateWalkInHours(walkIn, $event)"
              [type]="'number'"
            ></app-input>
          </div>
          <div class="detail status-detail">
            <span class="kbody-medium status new">{{
              walkIn.alreadyRegistered ? "to credit" : "to add"
            }}</span>
          </div>
          <div class="detail time">
            <app-input
              value="{{ walkIn.timeIn }}"
              placeholder="—"
              (change)="updateWalkInTime(walkIn, $event, 'timeIn')"
            ></app-input>
          </div>
          <div class="detail time">
            <app-input
              value="{{ walkIn.timeOut }}"
              placeholder="—"
              (change)="updateWalkInTime(walkIn, $event, 'timeOut')"
            ></app-input>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons">
      <app-button
        [text]="'Cancel'"
        [class]="'white'"
        (click)="this.dialogRef.close()"
      ></app-button>
      <app-button
        [disabled]="(getUpdatedUsers().length === 0 && walkIns.length === 0) || isResolvingWalkIns"
        [text]="'Save'"
        [icon]="{ materialtype: 'success' }"
        (click)="saveValidationUpdates()"
      ></app-button>
    </div>
  </div>
  <app-loading-spinner
    *ngIf="!sessionValidationDetails"
    class="spinner"
  ></app-loading-spinner>
</div>
